"use client";

import { LoadingSpinner } from "@/components/atoms/LoadingSpinner/LoadingSpinner";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
export default function Page() {
  const router = useRouter();
  useEffect(() => {
    router.replace("/copilot");
  }, [router]);
  return <LoadingSpinner size="large" cover data-sentry-element="LoadingSpinner" data-sentry-component="Page" data-sentry-source-file="page.tsx" />;
}